<template>
  <div v-if="multiCharacterView">
    <v-data-table :items="items" :headers="headers" hide-default-footer>
      <template v-slot:item.character="{ item }">
        <span :class="item.character.class.toLowerCase().replaceAll(' ', '-')">
          <b>{{ item.character.name}}</b>
        </span>
      </template>
      <template v-slot:item.user="{ item }">
        <v-icon class="mr-1 small">mdi-account</v-icon>
        <span v-if="item.user">{{ item.user.username }}</span>
      </template>
      <template v-slot:item.type="{ item }">
        <span v-if="item.type">{{ $t(`behaviour_log.type.${item.type.toLowerCase()}`) }}</span>
      </template>
      <template v-slot:item.executionDate="{ item }">
        <span>{{ new Date(item.executionDate).toLocaleDateString() }}</span>
      </template>
    </v-data-table>
  </div>
  <div v-else>
    <v-data-table :items="items" :headers="headers" hide-default-footer>
      <template v-slot:item.type="{ item }">
        <span v-if="item.type">{{ $t(`behaviour_log.type.${item.type.toLowerCase()}`) }}</span>
      </template>
      <template v-slot:item.executionDate="{ item }">
        <span>{{ new Date(item.executionDate).toLocaleDateString() }}</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "PlayerBehaviourDetails",
  props: ["items", "multiCharacterView"],
  data() {
    return {
      headers: [
        {text: this.$t('behaviour_log.headers.type'), value: "type"},
        {text: this.$t('behaviour_log.headers.sub_type'), value: "subType"},
        {text: this.$t('behaviour_log.headers.value'), value: "value"},
        {text: this.$t('behaviour_log.headers.reason'), value: "reason"},
        {text: this.$t('behaviour_log.headers.executionDate'), value: "executionDate"}
      ]
    }
  }
}
</script>

<style scoped>

</style>